import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-yearwise-app',
  templateUrl: './yearwise-app.component.html',
  styleUrls: ['./yearwise-app.component.scss']
})
export class YearwiseAppComponent {

  financialYears: string[] = [];
  selectedYear: string;

  constructor(public dialogRef: MatDialogRef<YearwiseAppComponent>) {
    this.generateFinancialYears();
  }

  generateFinancialYears() {
    const startYear = 2022;
    const today = new Date();
    const currentMonth = today.getMonth();
    let endYear = today.getFullYear();
    if (currentMonth < 3) endYear--;

    for (let y = startYear; y <= endYear; y++) {
      this.financialYears.push(`APR-${y} - MARCH-${y + 1}`);
    }
    this.financialYears.reverse();
  }

  selectYear() {

    debugger

    if (!this.selectedYear) {
      alert("Please select a year.");
      return;
    }

    const startDateStr = sessionStorage.getItem('startDate');
    const endDateStr = sessionStorage.getItem('endDate');

    const financialYearStart = new Date(startDateStr);
    const financialYearEnd = new Date(endDateStr);

    if (this.selectedYear) {
      const match = this.selectedYear.match(/APR-(\d{4}) - MARCH-(\d{4})/);
      if (match) {
        const startYear = match[1];
        const endYear = match[2];

        const startDate = `${startYear}-04-01`;
        const endDate = `${endYear}-03-31`;

        const mobile = sessionStorage.getItem("mobile");

        // New lock: Allow only years >= April-2025
        const lockStart = "2025-04-01";

        // Convert to comparable numbers YYYYMMDD
        const sNum = Number(startDate.replace(/-/g, ""));
        const eNum = Number(endDate.replace(/-/g, ""));
        const lockStartNum = Number(lockStart.replace(/-/g, ""));

        // If selected period is before 2025-04-01, block (except special mobile)
        if ((sNum < lockStartNum || eNum < lockStartNum) && mobile !== "9594961846") {
          alert("Year April-2025 / March-2026 Locked !!!");
          return;
        }

        // Store in localStorage
        sessionStorage.setItem('startDate', startDate);
        sessionStorage.setItem('endDate', endDate);

        // Get last 2 digits of years
        const startYearShort = startYear.slice(-4);
        const endYearShort = endYear.slice(-4);

        document.title = `Saptahik Vivek (${startYearShort}-${endYearShort})`;

        // Optional: you can return both dates with dialogRef if needed
        this.dialogRef.close({ selectedYear: this.selectedYear, startDate, endDate });
      } else {
        this.dialogRef.close(null);
      }
    }
  }

  cancel() {
    this.dialogRef.close(null);
  }

}